import Vue from 'vue';
import App from './App.vue';

import store from "./store/store";
import router from './router';

import { VueSpinners } from '@saeris/vue-spinners';
import VueSwal from 'vue-swal';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEuroSign, faClock, faUserEdit, faTrash, faPen, faUser, faTimes, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import VueI18n from 'vue-i18n';
import en from './locales/en.js';
import sk from './locales/sk.js';

library.add(faEuroSign, faClock, faUserEdit, faPen, faTrash, faUser, faTimes, faSignOutAlt);

Vue.config.productionTip = false;

Vue.use(VueSpinners);
Vue.use(VueSwal);

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'sk',
  messages: {
    en,
    sk
  }
});

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.filter('price', function (value) {
  if (typeof value !== "number") {
    return value;
  }

  let formatter = new Intl.NumberFormat('sk-SK', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
